export default __webpack_public_path__ + "static/media/telus.8e1e3ffe.png";